/**
 * DownloadQuoteGate — app-wide instance of ``useDownloadQuoteGate`` for
 * downloads started outside the Configure Deployment flow (the
 * training-complete toast). Listens for ``MODEL_DOWNLOAD_REQUEST_EVENT`` on
 * ``window`` (see ``requestGatedModelDownload``) and renders the quote modals.
 */
import React, { useEffect } from 'react';

import { useDownloadQuoteGate } from '../hooks/useDownloadQuoteGate';
import { MODEL_DOWNLOAD_REQUEST_EVENT } from '../utils/modelDownloadRequest';
import DownloadQuoteModals from './DownloadQuoteModals';

export function DownloadQuoteGate() {
    const gate = useDownloadQuoteGate();
    const { requestDownload, showInsufficientFromLastQuote } = gate;

    useEffect(() => {
        const onRequest = (event) => {
            const { items, onApproved } = event?.detail || {};
            if (!Array.isArray(items) || !items.length) return;
            requestDownload({
                items,
                onApproved: () => onApproved?.({ onPaymentRequired: showInsufficientFromLastQuote }),
            });
        };
        window.addEventListener(MODEL_DOWNLOAD_REQUEST_EVENT, onRequest);
        return () => window.removeEventListener(MODEL_DOWNLOAD_REQUEST_EVENT, onRequest);
    }, [requestDownload, showInsufficientFromLastQuote]);

    return <DownloadQuoteModals gate={gate} />;
}

export default DownloadQuoteGate;
